/**
 * @description 订单缺陷率
 *
 * @props {string} 
 *
 * @slot {插槽} 
 *
 */
<template>
  <div class="content">
    <div class="title">
      <div class="title-item">订单缺陷率</div>
      <div class="title-item">目标：低于1% </div>
      <div class="title-item">订单配送方：卖家 </div>
      <div class="title-item">时间范围：{{ orderDefects.duration }}天 </div>
      <div class="title-item">{{ orderDefects.timeFrameStart | convertToDate }} - {{ orderDefects.timeFrameEnd | convertToDate }}</div>
    </div>
    <div class="main">
      <div class="grid1" :style="{width: explain ? '10%' : '20%'}">
        <div class="rate" :class="{abnormal: !orderDefects.orderWithDefects.completeTarget}">{{ orderDefects.orderWithDefects.rate }}</div>
        <div class="col">
          <span>存在缺陷的订单数：</span>
          <span>{{ orderDefects.orderWithDefects.count }}</span>
        </div>
        <div class="col">
          <span>订单总数：</span>
          <span>{{ orderDefects.count }}</span>
        </div>
      </div>
      <div class="grid2" :style="{width: explain ? '50%' : '70%'}">
        <gj-base-table :columns="columns" :datas="datas"></gj-base-table>
      </div>
      <div class="message" v-if="explain">
        <div class="message-cell" v-for="(item, index) in message" :key="index">{{ item }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import gjBaseTable from "./gj-base-table.vue";
import { convertToDate } from "@/utils/date.util"
export default {
  props: {
    explain: {
      type: Boolean,
      default: true
    },
    orderDefects: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    "gj-base-table": gjBaseTable,
  },
  data() {
    return {
      columns: [
        {
          name: "缺陷类型",
          id: "flag1",
          width: "30%",
        },
        {
          name: "订单缺陷百分比",
          id: "flag2",
          width: "40%",
          textAlign: "right",
        },
        {
          name: "订单缺陷计数",
          id: "flag3",
          width: "30%",
          textAlign: "right",
        },
      ],
      message: [
        "订单缺陷率(ODR)是衡量您提供卓越的买家体验能力的主要指标。 ODR是在给定的60天时间段内存在缺陷（定义见下文）的所有订单数占订单总数的百分比。",
        "如果某笔订单存在负面反馈、亚马逊商城交易保障索赔（未被拒绝）或信用卡拒付，则该订单具有缺陷。",
        "亚马逊的政策规定，卖家需维持低于 1% 的ODR，才能在亚马逊上销售商品。 高于1% 的 ODR 可能会导致账户停用。",
      ],
    };
  },
  computed: {
    datas() {
      let datas = [
        { flag1: "负面反馈", flag2: "", flag3: "", completeTarget: true},
        { flag1: "亚马逊商城交易保障赔偿", flag2: "", flag3: "", completeTarget: true},
        { flag1: "信用卡拒付索赔", flag2: "", flag3: "", completeTarget: true},
      ]
      if (this.orderDefects.negativeFeedBacks) {
        let { rate, count, completeTarget } = this.orderDefects.negativeFeedBacks
        datas[0].flag2 = rate
        datas[0].flag3 = count
        datas[0].completeTarget = completeTarget
      }
      if (this.orderDefects.azclaims) {
        let { rate, count, completeTarget } = this.orderDefects.azclaims
        datas[1].flag2 = rate
        datas[1].flag3 = count
        datas[1].completeTarget = completeTarget
      }
      if (this.orderDefects.chargeBacks) {
        let { rate, count, completeTarget } = this.orderDefects.chargeBacks
        datas[2].flag2 = rate
        datas[2].flag3 = count
        datas[2].completeTarget = completeTarget
      }
      return datas
    }
  },
  filters: {
    convertToDate(val) {
      if (!val) { return "" }
      return convertToDate(new Date(val))
    }
  }
};
</script>

<style scoped lang="scss">
.abnormal {
  color: #F56C6C !important;
}
.content {
  padding-bottom: 10px;
  .title {
    line-height: 1;
    padding: 8px 0 18px 10px;
    font-size: 12px;
    display: flex;
    color: #666;
    .title-item {
      padding-left: 12px;
      &:first-child {
        padding-left: 0;
        font-weight: bold;
      }
      &:last-child {
        padding-left: 20px;
      }
    }
  }
  .main {
    display: flex;
    justify-content: space-between;
    .grid1 {
      width: 10%;
      padding-left: 50px;
      .rate {
        padding: 18px 0 0;
        font-size: 24px;
        font-weight: 600;
        color: #333;
      }
      .col {
        padding-top: 22px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        color: #666;
      }
    }
    .grid2 {
      width: 50%;
      padding: 0 33px 0 14px;
    }
    .message {
      width: 30%;
      font-size: 12px;
      color: #666;
      line-height: 20px;
      padding-right: 26px;
      padding-left: 14px;
      border-left: 1px solid #ccc;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }
  }
}
</style>